import { useAuth } from '@/lib/auth/auth';
import type { OrganizationMemberSummary } from '@/lib/api/apiTypes';
import { useQuery } from '@tanstack/react-query';

export const organizationMemberKeys = {
  all: ['organization-members'] as const,
  list: (organizationID: string) => [...organizationMemberKeys.all, organizationID] as const,
};

export function useOrganizationMembers(organizationID: string, enabled = true) {
  const session = useAuth((state) => state.session);
  const request = useAuth((state) => state.request);

  return useQuery({
    queryKey: organizationMemberKeys.list(organizationID),
    enabled: Boolean(session) && enabled && organizationID.length > 0,
    queryFn: () => request<OrganizationMemberSummary[]>(`/organizations/${organizationID}/members`),
  });
}
